module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-SemiBold.1d9bffb5.eot";